import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { type NormalizedRating } from "@src/appV2/redesign/Tiers/utils/types";

interface RatingExplanationHeaderProps {
  workerNormalizedRating: NormalizedRating;
  targetNormalizedRating: NormalizedRating;
  header: string;
  onClick: () => void;
}

const SPACE_BETWEEN_HEADER_ITEMS = "\u00A0".repeat(4);

export function RatingExplanationHeader(props: RatingExplanationHeaderProps) {
  const {
    workerNormalizedRating: {
      ratingType,
      rating: workerRating,
      display: workerRatingDisplay,
      ratingHasEvents: workerHasEvents,
    },
    targetNormalizedRating: { rating: targetRating, display: targetRatingDisplay },
    header,
    onClick,
  } = props;

  const isTargetRatingMet =
    ratingType === "shiftCompletionWithoutLateCancel"
      ? workerRating <= targetRating
      : workerRating >= targetRating;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Text semibold variant="h5">
        {header}
      </Text>
      <Stack direction="row" alignItems="center" gap={4}>
        {!workerHasEvents && ratingType !== "shiftCompletionWithoutLateCancel" && (
          <Text>
            <Text semibold variant="h5" sx={{ display: "inline" }}>
              {workerRatingDisplay}
            </Text>
          </Text>
        )}
        {((isTargetRatingMet && workerHasEvents) ||
          (ratingType === "shiftCompletionWithoutLateCancel" && !workerHasEvents)) && (
          <Stack direction="row" alignItems="center" gap={1}>
            <CbhIcon
              type="checkmark"
              size="large"
              sx={{
                display: "flex",
                alignItems: "center",
                color: (theme) => theme.palette.success.main,
              }}
            />
            <Text inline semibold variant="h5">
              {workerRatingDisplay}
            </Text>
          </Stack>
        )}
        {!isTargetRatingMet && workerHasEvents && (
          <Text>
            <Text semibold variant="h5" sx={{ display: "inline" }}>
              {workerRatingDisplay}
              {SPACE_BETWEEN_HEADER_ITEMS}→{SPACE_BETWEEN_HEADER_ITEMS}
            </Text>
            <Text
              semibold
              color={(theme) => theme.palette.success.main}
              variant="h5"
              sx={{ display: "inline" }}
            >
              {targetRatingDisplay}
            </Text>
          </Text>
        )}
        <IconButton iconType="chevron-right" variant="outlined" size="xSmall" onClick={onClick} />
      </Stack>
    </Stack>
  );
}
